import { render } from "./BaseNode.vue?vue&type=template&id=16257250"
import script from "./BaseNode.vue?vue&type=script&lang=js"
export * from "./BaseNode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__